import { useReducedMotion } from "hooks/useReducedMotion";
import Lottie, {
	type LottieComponentProps,
	type LottieRefCurrentProps,
} from "lottie-react";
import { useEffect, useRef } from "react";

interface LottieAnimationProps {
	animationData: LottieComponentProps["animationData"];
	loop?: boolean;
	autoplay?: boolean;
	speed?: number;
	style?: React.CSSProperties;
	className?: string;
}

export function LottieAnimation({
	animationData,
	loop = true,
	autoplay = true,
	speed,
	style,
	className,
}: LottieAnimationProps) {
	const reduced = useReducedMotion();
	const lottieRef = useRef<LottieRefCurrentProps>(null);

	useEffect(() => {
		if (lottieRef.current && speed != null) {
			lottieRef.current.setSpeed(speed);
		}
	}, [speed]);

	return (
		<Lottie
			lottieRef={lottieRef}
			animationData={animationData}
			loop={reduced ? false : loop}
			autoplay={reduced ? false : autoplay}
			initialSegment={reduced ? [0, 1] : undefined}
			style={style}
			className={className}
			rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
		/>
	);
}
